module.exports = __webpack_public_path__ + "img/server.91f4800b.svg";